import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';



const Banner = () => {

  return (
    <section className="banner">
      <div className='content'>

        <Heading title={"Empowering Innovation with AI & IT Excellence"} subTitle={"Smart. Scalable. Future-Ready"} linear />
        <p>We deliver intelligent digital solutions designed to streamline operations, boost productivity, and fuel growth. TechNova is your partner in building a smarter tomorrow.</p>
        <Button link={"Get-Quote"} title={"Request a Demo"} />

      </div>
    </section>
  );

};

export default Banner;